import { SystemReflectionStatusEnum } from './system-reflection-status-enum'
import { SystemReflectionTypeEnum } from './system-reflection-type-enum'
import { BaseSchool } from './base-school'

export interface SystemReflectionInterface {
  name: string
  /**
   * 账户
   */
  account: string
  phone?: string | null
  /**
   * 状态
   */
  status?: SystemReflectionStatusEnum
  /**
   * 类型
   */
  type?: SystemReflectionTypeEnum
  email?: string | null
  avatar?: string | null
  remark: string
  /**
   * 管理的学校 ID
   */
  managedSchoolIds?: number[]
  /**
   * 管理的学校
   */
  managedSchools?: BaseSchool[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class SystemReflection implements SystemReflectionInterface {
  name: string
  /**
   * 账户
   */
  account: string
  phone?: string | null
  /**
   * 状态
   */
  status?: SystemReflectionStatusEnum
  /**
   * 类型
   */
  type?: SystemReflectionTypeEnum
  email?: string | null
  avatar?: string | null
  remark: string
  /**
   * 管理的学校 ID
   */
  managedSchoolIds?: number[]
  /**
   * 管理的学校
   */
  managedSchools?: BaseSchool[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: SystemReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      account: _account,
      phone: _phone,
      status: _status,
      type: _type,
      email: _email,
      avatar: _avatar,
      remark: _remark,
      managedSchoolIds: _managedSchoolIds,
      managedSchools: _managedSchools,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.account = _account
    this.phone = _phone
    this.status = _status
    this.type = _type
    this.email = _email
    this.avatar = _avatar
    this.remark = _remark
    this.managedSchoolIds = _managedSchoolIds
    this.managedSchools = _managedSchools
      ? _managedSchools.map((i) => new BaseSchool(i))
      : _managedSchools
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
